// Webpack Imports
import jQuery from 'jquery';
import * as bootstrap from 'bootstrap';



// make Carousel a jQuery plugin
import Carousel from 'bootstrap/js/dist/carousel';

( function ($, window, document, undefined) {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	var modalTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="modal"]' ) );
	var modalList = modalTriggerList.map( function ( modalTriggerEl ) {
		return new bootstrap.Modal( modalTriggerEl, {
			trigger: 'focus',
		} );
	} );


	if($(window).width() >= 980 && $('#toc_container').length){
		//console.log('Attaching TOC');
		var toc = $('#toc_container');
		$('#sidebar').first().prepend(toc);
	}
	
	$('#toc_container .toc_title').on('click', function(){
		
		if($(this).parent().next().is(':visible')){
			$(this).parent().next().slideUp();
			$(this).removeClass('active');
		}else{
			$(this).parent().next().slideDown();
			$(this).addClass('active');
		}
		
	});

	$('.wp-block-social-links a').click(function(){
    window.open(this.href);
    return false;
  });


} )(jQuery, window, document);


// var myCarousel = document.querySelector('#carouselExampleIndicators')
// var carousel = new bootstrap.Carousel(myCarousel, {
//     interval: 500
// })